import React from 'react'

import {
  Container,
  FormWrapper,
  Header,
  NavigatorContainer,
} from './styles'

import NavCheckpoint from '../../../../components/finance/nav-checkpoint'
import FormFactory from '../../../../components/form/form-factory'

const ConfigNFCe = ({
  dataForm,
  onSubmit,
  initialData,
  currentStep,
  onChangeStep,
}: any) => (
  <>
    <Header />
    <Container>
      <NavigatorContainer>
        <NavCheckpoint
          currentIndex={currentStep}
          onChangeStep={onChangeStep}
          pageNames={['Endereço', 'Dados da empresa']}
        />
      </NavigatorContainer>
      <FormWrapper>
        <FormFactory
          data={dataForm}
          onSubmit={onSubmit}
          initialData={initialData}
        />
      </FormWrapper>
    </Container>
  </>
)

export default ConfigNFCe
